<template>
    <div>
        <div v-if="product.raw_materials.length">
            <b-card v-for="rm in product.raw_materials"
                    v-if="rm.name.trim().toLowerCase().includes(name.trim().toLowerCase())"
                    class="mt-2 mb-0 border-card-info"
                    no-body
            >
                <b-row>
                    <b-col md="3"
                           class="pr-0"
                    >
                        <div class="bg-light p-3 h-100"  style="border-radius: 6px 0 0 6px">
                            <h5 class="font-weight-bold">{{ rm.name }}</h5>

                            <label class="text-truncate font-weight-bold text-black-50">
                                % Usado en la preparación
                            </label>
                            <input_formatter v-model="rm.percentage"
                                             symbol="%"
                                             :position_symbol="false"
                                             :decimals="4"
                                             input_class="text-center"
                                             @changeInput="changePercentage(rm)"
                                             v-if="!only_view"
                            />
                            <div v-else>
                                {{ rm.percentage }}%
                            </div>
                            <div>
                                <b-progress :value="rm.percentage"
                                            :max="100"
                                            show-progress
                                            height="10px"
                                            class="mt-1 bg-white"
                                            precision="1"
                                            :show-progress="false"
                                />
                            </div>
                        </div>
                    </b-col>

                    <b-col md="9"
                           class="pl-md-3 pr-md-4 py-md-3 py-2 px-4"
                    >
                        <b-row>
                            <b-col>
                                <h5 class="mb-2 font-weight-bold mt-md-0 mt-2 ">
                                    <i class="fa fa-cubes"></i> Componentes
                                    <b-badge :variant="rm.components.filter(comp => !comp.omit_in_composition).length ? 'success' : 'warning'"
                                    >
                                        {{
                                            rm.components.filter(comp => !comp.omit_in_composition).length
                                        }}
                                    </b-badge>
                                </h5>
                            </b-col>
                        </b-row>
                        <b-row v-for="(c, i) in rm.components.filter(comp => !comp.omit_in_composition)"
                               class="my-2"
                        >
                            <b-col cols="12"
                                   class="font-weight-bold mb-2 text-primary"
                            >
                                <i class="fa fa-cube"/>
                                {{ c.cas_number }} - {{ c.name }}
                            </b-col>

                            <b-col md="6">
                                <label class="text-truncate font-weight-bold text-black-50">
                                    % Máximo reportado en la FDS de la materia prima
                                </label>
                                <input_formatter v-model="c.reported_percentage"
                                                 symbol="%"
                                                 :position_symbol="false"
                                                 :decimals="4"
                                                 input_class="text-center"
                                                 @changeInput="changeReportedPercentage(rm, c)"
                                                 v-if="!only_view"
                                />
                                <div v-else>
                                    {{ c.reported_percentage }}%
                                </div>
                            </b-col>
                            <b-col md="6">
                                <label class="text-truncate font-weight-bold text-center text-black-50">
                                    % Final en la mezcla
                                </label>
                                <div class="text-center">
                                    <div class="text-center w-100 pr-2 mt-1"
                                         style="z-index: 10; position:absolute; color: rgb(96, 98, 102);"
                                    >
                                        {{ c.final_percentage }}%
                                    </div>
                                    <el-progress :percentage="c.final_percentage"
                                                 :stroke-width="27"
                                                 :format="format"
                                                 color="#4dbd74"
                                                 :show-text="false"
                                    />
                                </div>
                            </b-col>

                            <b-col md="12"
                                   v-if="c.sga_categories.length"
                                   class="mt-2"
                            >
                                <label class="text-truncate font-weight-bold text-black-50">
                                    SGA
                                    <b-badge variant="secondary"
                                             class="float-right ml-2"
                                    >
                                        <span>
                                            {{
                                                c.sga_categories.length
                                            }}
                                        </span>
                                    </b-badge>
                                </label>
                                <b-row>
                                    <b-col md="6"
                                           v-for="s in c.sga_categories"
                                           class="text-truncate"
                                    >
                                        <b-badge variant="primary"
                                                 style="width: 40px"
                                                 class="mr-1"
                                        >
                                            {{ s.category.codigo }}
                                        </b-badge>
                                        {{ s.category.categoria }}
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col v-else
                                   class="mt-2"
                            >
                                <label class="text-truncate font-weight-bold text-black-50">
                                    SGA
                                </label>
                                <b-row>
                                    <b-col md="6"
                                           class="text-truncate"
                                    >
                                        NO REPORTADO
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="12">
                                <hr class="mt-2 mb-1">
                            </b-col>
                        </b-row>
                        <b-row v-if="!rm.components.filter(comp => !comp.omit_in_composition).length">
                            <b-col cols="12"
                                   class="text-center my-2 text-black-50"
                            >
                                <i class="fa fa-warning"/>
                                No hay componentes para mostrar
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-button variant="danger"
                                          class="float-right mr-1"
                                          size="sm"
                                          @click="_deleteRawMaterial(rm)"
                                >
                                    <i class="fa fa-trash"/> Eliminar
                                </b-button>

                                <b-button variant="primary"
                                          class="float-right mr-1"
                                          size="sm"
                                          @click="openModalForEdition(rm)"
                                >
                                    <i class="fa fa-edit"/> Editar
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>

            <b-card class="mt-2 mb-0 border-card-warning"
                    body-class="p-3"
            >
                <h5 class="font-weight-bold mb-0">
                    Total: {{ product.total_percentage }}%
                </h5>
            </b-card>
        </div>
        <div v-else>
            <b-card class="mt-3 mb-0"
                    body-class="p-3 text-center"
            >
                <h6 class="text-muted my-4 ">
                    No hay materias primas para mostrar
                </h6>
                <b-button variant="primary"
                          size="sm"
                          @click="$emit('create')"
                >
                    <i class="fa fa-plus"/> Agregar
                </b-button>
            </b-card>
        </div>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import component from './component';
import new_component from './new_component';
import wizard from './wizard.vue';
import input_formatter from '../../components/input_formatter';

export default {
    name: 'index',
    props: {
        name: {
            required: false,
            default: '',
            type: String
        }
    },
    components: {
        wizard,
        component,
        new_component,
        input_formatter
    },
    data() {
        return {
            columns: [
                {
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'percentage',
                    label: 'Porcentaje usado'
                },
                {
                    key: 'components',
                    label: 'Componentes'
                },
                {
                    key: 'actions',
                    label: ''
                }
            ]
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'raw_material',
            'modal_components',
            'modal_wizard',
            'only_view'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'deleteRawMaterial',
            'updateRawMaterial',
            'getProduct',
            'updateComponents',
            'downloadComposition',
            'updateComponentProduct',
            'getRawMaterial',
            'createRawMaterial',
            'updateRawMaterial'
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setActionRawMaterialShow',
            'setRawMaterial',
            'setModalComponentsShow',
            'setShowToModalWizard',
            'setStepToModalWizard',
            'resetRawMaterial',
            'setActionToModalRawMaterial',
            'setShowToModalRawMaterial'
        ]),
        format(percentage) {
            return percentage === 100 ? 'Full' : `${percentage}%`;
        },
        async openModalForEdition(raw_material) {
            this.setActionToModalRawMaterial('u');
            await this.getRawMaterial(raw_material);
            this.setShowToModalRawMaterial(true);
        },
        openModalForCreation() {
            this.resetRawMaterial();
            this.setStepToModalWizard(0);
            this.setActionRawMaterialShow('Crear');
            this.setShowToModalWizard(true);
        },
        async _deleteRawMaterial(rm) {
            await this.deleteRawMaterial(rm);

            await this.getProduct({
                product_id: this.product.id,
                company_id: this.product.slq_company_id
            });
        },
        async changePercentage(rm) {
            let reg = new RegExp('^(\\d{0,2}(\\.\\d{1,2})?|100(\\.00?)?)$');

            if (reg.test(rm.percentage.toString())) {
                this.setActionToModalRawMaterial('u');
                this.setRawMaterial(rm)
                await this.updateRawMaterial();

                const product_id = this.$route.params.product_id;
                const company_id = this.$route.params.company_id;

                if (!!product_id && !!company_id) {
                    await this.getProduct({product_id, company_id});
                }
            }
        },
        async changeReportedPercentage(rm, c) {
            let reg = new RegExp('^(\\d{0,2}(\\.\\d{1,2})?|100(\\.00?)?)$');

            if (reg.test(c.reported_percentage.toString())) {
                this.setActionToModalRawMaterial('u');
                this.setRawMaterial(rm)
                await this.updateRawMaterial();

                const product_id = this.$route.params.product_id;
                const company_id = this.$route.params.company_id;

                if (!!product_id && !!company_id) {
                    await this.getProduct({product_id, company_id});
                }
            }
        }
    }
};
</script>

<style>
.border-card-info {
    border: 1px solid #f1f1f1;
    border-left: 4px solid #4dbd74 !important;
    border-radius: 10px;
    box-shadow: 0 0 8px #c9c9c9;
}

.border-card-warning {
    border-left: 4px solid #ffb500 !important;
}

.text-progress {
    font-size: 12px;
}
</style>
